import { useContext } from 'react';

import { SecurityGraphContext } from 'containers/Visibility/SecurityGraphNext/context/SecurityGraphContext';

export const useSecurityGraphContext = () => useContext(SecurityGraphContext);
